import styled from 'styled-components';
import { Block } from 'style/styleComponent/styled';

export const Container = styled.div`
  margin: 0 15px;

  @media all and (min-width: 0px) and (max-width: 320px) {
    margin: 0 10px;
  }
`;

export const ContentWrapper = styled.div`
  background: white;
  border-radius: 8px;
  font-family: 'inter-regular', sans-serif;
`;

export const BlockHeader = styled(Block)`
  border-radius: 8px 8px 0 0;
`;

export const BlockFooter = styled(Block)`
  border-radius: 0 0 8px 8px;
`;
